/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiSanctionEntityType } from './ApiSanctionEntityType';
import {
    ApiSanctionEntityTypeFromJSON,
    ApiSanctionEntityTypeFromJSONTyped,
    ApiSanctionEntityTypeToJSON,
    ApiSanctionEntityTypeToJSONTyped,
} from './ApiSanctionEntityType';
import type { ApiSanctionType } from './ApiSanctionType';
import {
    ApiSanctionTypeFromJSON,
    ApiSanctionTypeFromJSONTyped,
    ApiSanctionTypeToJSON,
    ApiSanctionTypeToJSONTyped,
} from './ApiSanctionType';
import type { ApiScreeningTestScreenableField } from './ApiScreeningTestScreenableField';
import {
    ApiScreeningTestScreenableFieldFromJSON,
    ApiScreeningTestScreenableFieldFromJSONTyped,
    ApiScreeningTestScreenableFieldToJSON,
    ApiScreeningTestScreenableFieldToJSONTyped,
} from './ApiScreeningTestScreenableField';
import type { ApiScreeningDirection } from './ApiScreeningDirection';
import {
    ApiScreeningDirectionFromJSON,
    ApiScreeningDirectionFromJSONTyped,
    ApiScreeningDirectionToJSON,
    ApiScreeningDirectionToJSONTyped,
} from './ApiScreeningDirection';

/**
 * 
 * @export
 * @interface ApiScreeningTest
 */
export interface ApiScreeningTest {
    /**
     * 
     * @type {number}
     * @memberof ApiScreeningTest
     */
    id?: number;
    /**
     * 
     * @type {ApiSanctionEntityType}
     * @memberof ApiScreeningTest
     */
    entityType: ApiSanctionEntityType;
    /**
     * 
     * @type {Array<ApiScreeningTestScreenableField>}
     * @memberof ApiScreeningTest
     */
    screenableFields?: Array<ApiScreeningTestScreenableField>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ApiScreeningTest
     */
    selectorGroupCodes?: Array<string>;
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiScreeningTest
     */
    clearanceRules?: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof ApiScreeningTest
     */
    minId?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiScreeningTest
     */
    maxId?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiScreeningTest
     */
    currentId?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiScreeningTest
     */
    status?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiScreeningTest
     */
    goodlistEnabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiScreeningTest
     */
    useExistingHits?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiScreeningTest
     */
    useOnlyScreenedEntities?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiScreeningTest
     */
    exemptionRulesEnabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiScreeningTest
     */
    skipFilteredAlerts?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ApiScreeningTest
     */
    scoreThreshold?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiScreeningTest
     */
    bicLengthThreshold?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ApiScreeningTest
     */
    applicationFeatures?: Array<string>;
    /**
     * 
     * @type {ApiScreeningDirection}
     * @memberof ApiScreeningTest
     */
    screeningDirection: ApiScreeningDirection;
    /**
     * 
     * @type {ApiSanctionType}
     * @memberof ApiScreeningTest
     */
    screeningListType?: ApiSanctionType;
    /**
     * 
     * @type {string}
     * @memberof ApiScreeningTest
     */
    customListCode?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ApiScreeningTest
     */
    recordExternalIds?: Array<string>;
}



/**
 * Check if a given object implements the ApiScreeningTest interface.
 */
export function instanceOfApiScreeningTest(value: object): value is ApiScreeningTest {
    if (!('entityType' in value) || value['entityType'] === undefined) return false;
    if (!('screeningDirection' in value) || value['screeningDirection'] === undefined) return false;
    return true;
}

export function ApiScreeningTestFromJSON(json: any): ApiScreeningTest {
    return ApiScreeningTestFromJSONTyped(json, false);
}

export function ApiScreeningTestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiScreeningTest {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'entityType': ApiSanctionEntityTypeFromJSON(json['entityType']),
        'screenableFields': json['screenableFields'] == null ? undefined : ((json['screenableFields'] as Array<any>).map(ApiScreeningTestScreenableFieldFromJSON)),
        'selectorGroupCodes': json['selectorGroupCodes'] == null ? undefined : json['selectorGroupCodes'],
        'clearanceRules': json['clearanceRules'] == null ? undefined : json['clearanceRules'],
        'minId': json['minId'] == null ? undefined : json['minId'],
        'maxId': json['maxId'] == null ? undefined : json['maxId'],
        'currentId': json['currentId'] == null ? undefined : json['currentId'],
        'status': json['status'] == null ? undefined : json['status'],
        'goodlistEnabled': json['goodlistEnabled'] == null ? undefined : json['goodlistEnabled'],
        'useExistingHits': json['useExistingHits'] == null ? undefined : json['useExistingHits'],
        'useOnlyScreenedEntities': json['useOnlyScreenedEntities'] == null ? undefined : json['useOnlyScreenedEntities'],
        'exemptionRulesEnabled': json['exemptionRulesEnabled'] == null ? undefined : json['exemptionRulesEnabled'],
        'skipFilteredAlerts': json['skipFilteredAlerts'] == null ? undefined : json['skipFilteredAlerts'],
        'scoreThreshold': json['scoreThreshold'] == null ? undefined : json['scoreThreshold'],
        'bicLengthThreshold': json['bicLengthThreshold'] == null ? undefined : json['bicLengthThreshold'],
        'applicationFeatures': json['applicationFeatures'] == null ? undefined : json['applicationFeatures'],
        'screeningDirection': ApiScreeningDirectionFromJSON(json['screeningDirection']),
        'screeningListType': json['screeningListType'] == null ? undefined : ApiSanctionTypeFromJSON(json['screeningListType']),
        'customListCode': json['customListCode'] == null ? undefined : json['customListCode'],
        'recordExternalIds': json['recordExternalIds'] == null ? undefined : json['recordExternalIds'],
    };
}

export function ApiScreeningTestToJSON(json: any): ApiScreeningTest {
    return ApiScreeningTestToJSONTyped(json, false);
}

export function ApiScreeningTestToJSONTyped(value?: ApiScreeningTest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'entityType': ApiSanctionEntityTypeToJSON(value['entityType']),
        'screenableFields': value['screenableFields'] == null ? undefined : ((value['screenableFields'] as Array<any>).map(ApiScreeningTestScreenableFieldToJSON)),
        'selectorGroupCodes': value['selectorGroupCodes'],
        'clearanceRules': value['clearanceRules'],
        'minId': value['minId'],
        'maxId': value['maxId'],
        'currentId': value['currentId'],
        'status': value['status'],
        'goodlistEnabled': value['goodlistEnabled'],
        'useExistingHits': value['useExistingHits'],
        'useOnlyScreenedEntities': value['useOnlyScreenedEntities'],
        'exemptionRulesEnabled': value['exemptionRulesEnabled'],
        'skipFilteredAlerts': value['skipFilteredAlerts'],
        'scoreThreshold': value['scoreThreshold'],
        'bicLengthThreshold': value['bicLengthThreshold'],
        'applicationFeatures': value['applicationFeatures'],
        'screeningDirection': ApiScreeningDirectionToJSON(value['screeningDirection']),
        'screeningListType': ApiSanctionTypeToJSON(value['screeningListType']),
        'customListCode': value['customListCode'],
        'recordExternalIds': value['recordExternalIds'],
    };
}

